export default __webpack_public_path__ + "95b5e05100a3fd03b40a6cab7c721b24.mp4";